import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import {
  BackofficeConversationSalesReportExportBodySchema,
  BackofficeConversationSalesReportExportResponseDataSchema,
  DataResponse,
} from "schema"
import { toast } from "sonner"
import { z } from "zod"

type Props = z.input<typeof BackofficeConversationSalesReportExportBodySchema>
type Response = DataResponse<
  z.infer<typeof BackofficeConversationSalesReportExportResponseDataSchema>
>

export function useExportConversationSalesReportMutation() {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (props: Props) => {
      const response = await axios.post<Response>(
        "/backoffice/conversationSalesReports/export",
        props,
      )

      return response.data.data
    },
    onSuccess: () => {
      toast.success(t("backoffice.conversationSalesReports.requestSuccess"))
    },
  })
}
